/**
 * Debounce a function so it doesn't fire until waiting a set amount of time
 * @param {Function} func
 * @param {number} delay in milliseconds
 * @returns {Function}
 */
export function debounce(func, delay) {
  var timeout = null
  return function(...args) {
    clearTimeout(timeout)
    timeout = setTimeout(function() {
      func(...args)
    }, delay)
  }
}

export const preventRedirect = () => event => {
  event.preventDefault()
  event.stopPropagation()
}

export const hideInProduction = node => {
  return process.env.REACT_APP_NODE_ENV === 'prod' ? null : node
}

// eslint-disable-next-line no-undef
// export const gtag = () => window.dataLayer.push(arguments)

export const gtagWrapper = ({ event, ...params } = {}) => {
  try {
    if (window.dataLayer && event) {
      //console.log(event, params);
      window.dataLayer.push({
        event,
        params,
      })
    }
  } catch (error) {
    console.error('ERROR_gtag', error)
  }
}

export const isProduction = () => process.env.REACT_APP_NODE_ENV === 'prod'
export const isLocal = () => process.env.REACT_APP_NODE_ENV === 'dev'

const hubspotToken = process.env.REACT_APP_HUBSPOT_API_TOKEN
export const postHubSpot = async (params = {}) => {
  const { email } = params
  const hubSpotStages = [
    'INTERESTED | SIGNUP', // "INTERESTED | SIGNUP"
    'CAMPAIGN STARTED', // "CAMPAIGN STARTED"
    'TARGET | REACH', // "TARGET | REACH"
    'DESIGN FLYER', // "DESIGN FLYER"
    'DETAILS PAGE', // "DETAILS PAGE"
    'QUOTE', // "QUOTE"
    'CLOSED WON', // "CLOSED WON"
  ]

  // Disallow Promofy emails
  if (params && !email.includes('oppizi.com')) {
    const {
      deal_id,
      pipeline: deal_pipeline_label,
      stage_id,
      campaign_id,
      firstname,
      lastname,
      phone,
      campaign_name,
      amount,
      logrocket_sessions,
      company_name,
      currency: deal_currency_code,
      company_id,
      contact_id,
      email,
      country,
      oppizi_source,
    } = params
    const body = {
      deal: {
        deal_id,
        deal_pipeline_label,
        deal_stage_label: hubSpotStages[stage_id],
        campaign_id,
        firstname,
        lastname,
        campaign_name,
        amount,
        logrocket_sessions,
        company_name,
        deal_currency_code,
        country,
        company_id,
        contact_id,
      },
      contact: {
        email,
        contact_id,
        firstname,
        lastname,
        phone,
        country,
        oppizi_source,
      },
      company: {
        company_id,
        company_name,
        country,
      },
    }

    return await fetch(
      isProduction()
        ? 'https://hubspot.oppizi.com/deal/'
        : 'https://phoebe-hubspot.oppizi.com/deal/',
      {
        method: 'POST',
        body: JSON.stringify(body),
        headers: new Headers({
          Authorization: `Bearer ${hubspotToken}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      },
    )
      .then(result => result.json())
      .catch(err => {
        console.error(err)
      })
  }
  return {
    deal_id: null,
    success: false,
    message: 'Please provide parameters',
  }
}

export const getPosthogCrossDomainParams = () => {
  const hashParams = new URLSearchParams(window.location.search)
  return {
    distinct_id: hashParams.get('posthog_distinct_id'),
    session_id: hashParams.get('posthog_session_id'),
  }
}

/* Hide part of the email for security reasons */
export const hideEmail = email => {
  const [name, domain] = email.split('@')
  const hiddenNameLength = Math.max(name.length - 4, 0)
  const hiddenName = name.slice(0, 4) + '*'.repeat(hiddenNameLength)
  return `${hiddenName}@${domain}`
}
